import {
  useController,
  type FieldValues,
  type UseControllerProps,
} from "react-hook-form";
import { Input, type IInputProps } from "@components/inputs/Input/Input";

export type TFormInputProps<T extends FieldValues> = IInputProps &
  UseControllerProps<T>;

export const FormInput = <T extends FieldValues>({
  name,
  control,
  rules,
  ...rest
}: TFormInputProps<T>) => {
  const controller = useController({
    name,
    control,
    rules,
  });

  const {
    field,
    fieldState: { error },
  } = controller;

  const { ref: fieldRef, ...fieldRest } = field;

  return (
    <Input
      {...rest}
      {...fieldRest}
      ref={fieldRef}
      error={error?.message}
      {...(rest.disabled ? { disabled: true } : {})}
      {...(rest.onBlur
        ? {
            onBlur: (e) => {
              rest.onBlur?.(e);
              fieldRest.onBlur?.();
            },
          }
        : {})}
    />
  );
};
